export const CALENDLY_SALES_DESTINATIONS = {
  mcat: {
    advising: 'academic-advising-mo6x/premed-advising',
    tutoring: 'academic-advising-mo6x/wizeprep-mcat-tutoring',
  },
  lsat: {
    advising: 'lsat-academic-advising/free-lsat-prelaw-advising-session',
    tutoring: 'lsat-academic-advising/wizeprep-lsat-tutoring',
  },
  dat: {
    advising: 'd/cv8d-y89-dnz/complimentary-dat-and-pre-dent-advising-session',
    tutoring: 'dat-academic-advising-qhkr/dat-private-tutoring-consultation',
  },
  sat: {
    advising: 'sat-academic-advising/sat-academic-advising-session',
    tutoring: 'sat-academic-advising/sat-academic-advising-session-tutoring',
  },
  act: {
    advising: 'act-academic-advising/act-academic-advising-session',
    tutoring: 'act-academic-advising/act-academic-advising-session-tutoring',
  },
};
